"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function TRminosYCondiciones() {
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: signatureRef,
    isVisible: signatureVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const philosophyParagraphs = [{
    id: 1,
    text: "Al acceder a TimeArrival, usted acepta quedar vinculado por estos términos de servicio, todas las leyes y regulaciones aplicables, y acepta que es responsable del cumplimiento de cualquier ley local aplicable. El presente sitio web y los servicios asociados a la marca TIMEARRIVAL son operados por Leads Media Digital LLC, sociedad constituida conforme a las leyes del Estado de Delaware (Estados Unidos).\n\nCorreo electrónico de contacto: contacto@timearrival.com",
    highlight: "Identificación del titular"
  }, {
    id: 2,
    text: "Al acceder, registrarse o utilizar el sitio web y/o los servicios de TIMEARRIVAL, el usuario acepta quedar legalmente vinculado por los presentes Términos y Condiciones.\n\nSi el usuario no está de acuerdo con alguno de estos términos, deberá abstenerse de utilizar el sitio web o los servicios.",
    highlight: "Aceptación de los Términos"
  }, {
    id: 3,
    text: "TIMEARRIVAL ofrece soluciones de optimización logística, bajo el modelo de software como servicio (SaaS), que pueden incluir, entre otras funcionalidades:\n\nSeguimiento y localización de vehículos\nVisualización de rutas, trayectos y paradas\nInformes operativos y de actividad\nLas funcionalidades concretas dependerán del plan contratado y de la información publicada en el sitio web en cada momento.",
    highlight: "Descripción de los servicios"
  }, {
    id: 4,
    text: "El usuario reconoce expresamente que:\n\nEl servicio rastrea activos, no personas.\nTIMEARRIVAL no rastrea teléfonos móviles, identidades personales ni datos biométricos.\nLos datos de localización están asociados al vehículo o activo, no al conductor u ocupantes.",
    highlight: "Naturaleza del servicio y ausencia de rastreo personal"
  }, {
    id: 5,
    text: "Para acceder a determinados servicios, el usuario deberá crear una cuenta.\n\nEl usuario es responsable de:\n\nProporcionar información veraz y actualizada\nMantener la confidencialidad de sus credenciales\nTodas las actividades realizadas desde su cuenta\nTIMEARRIVAL no será responsable del uso no autorizado derivado de una negligencia del usuario.",
    highlight: "Registro de cuenta y responsabilidades del usuario"
  }, {
    id: 6,
    text: "El usuario se compromete a utilizar los servicios de TIMEARRIVAL de conformidad con la legislación aplicable en su jurisdicción.\n\nEn particular, el usuario declara y garantiza que:\n\nTiene derecho legal a instalar el dispositivo GPS en el vehículo\nEs propietario del vehículo o cuenta con autorización suficiente\nEn caso de vehículos conducidos por terceros, ha informado adecuadamente y obtenido los consentimientos legalmente exigibles\nTIMEARRIVAL no controla ni supervisa el uso que cada cliente realiza del servicio y queda expresamente exonerado de cualquier responsabilidad derivada del uso indebido, ilícito o no autorizado del sistema.",
    highlight: "Uso lícito del servicio y responsabilidad legal"
  }, {
    id: 7,
    text: "Los servicios se ofrecen bajo modalidad de suscripción mensual, trimestral o anual, según el plan contratado.\n\nLos precios, condiciones y características se indicarán en la oferta comercial y/o en el contrato de servicios.\nEl método de pago podrá variar y será informado al usuario antes de la contratación.\nSalvo que se indique expresamente, los pagos no son reembolsables.",
    highlight: "Planes, pagos y facturación"
  }, {
    id: 8,
    text: "El usuario podrá cancelar su suscripción en cualquier momento, con un preaviso mínimo de quince (15) días antes de la fecha de renovación.\n\nLa cancelación evitará futuros cargos\nEl servicio permanecerá activo hasta el final del periodo ya abonado\nNo se realizarán reembolsos por periodos ya facturados",
    highlight: "Cancelación del servicio"
  }, {
    id: 9,
    text: "TIMEARRIVAL se reserva el derecho de suspender o cancelar el acceso al servicio, sin previo aviso, cuando detecte:\n\nUso ilícito o fraudulento del sistema\nIncumplimiento de estos Términos\nRiesgo legal o reputacional para TIMEARRIVAL",
    highlight: "Suspensión o terminación por incumplimiento"
  }, {
    id: 10,
    text: "TIMEARRIVAL adopta medidas razonables para garantizar la seguridad y continuidad del servicio, pero no garantiza la disponibilidad ininterrumpida ni la ausencia de errores.\n\nEl usuario acepta que el servicio puede verse afectado por:\n\nMantenimiento técnico\nFallos de red\nLimitaciones de terceros proveedores\nImpago de la mensualidad o anualidad correspondiente.",
    highlight: "Seguridad y disponibilidad del servicio"
  }, {
    id: 11,
    text: "En la máxima medida permitida por la ley aplicable:\n\nTIMEARRIVAL no será responsable por daños indirectos, incidentales, consecuentes o pérdida de beneficios\nLa responsabilidad total de TIMEARRIVAL, en su caso, no excederá del importe efectivamente pagado por el usuario en los últimos 3 meses de servicio",
    highlight: "Limitación de responsabilidad"
  }, {
    id: 12,
    text: "Todo el software, marcas, contenidos y elementos gráficos asociados a TIMEARRIVAL son propiedad exclusiva de TIMEARRIVAL o de sus licenciantes.\n\nEl usuario obtiene únicamente un derecho de uso limitado, no exclusivo y no transferible durante la vigencia del contrato.",
    highlight: "Propiedad intelectual"
  }, {
    id: 13,
    text: "TIMEARRIVAL podrá modificar estos Términos y Condiciones en cualquier momento.\nLas versiones actualizadas se publicarán en el sitio web y serán aplicables desde su publicación.",
    highlight: "Modificaciones de los Términos"
  }, {
    id: 14,
    text: "Estos Términos y Condiciones se rigen e interpretan conforme a las leyes del Estado de Delaware (EE. UU.), con exclusión de normas sobre conflicto de leyes.\n\nCualquier disputa se someterá a los tribunales competentes de dicho Estado, salvo que TIMEARRIVAL opte por arbitraje.\n\n",
    highlight: "Ley aplicable y jurisdicción"
  }, {
    id: 15,
    text: "Para cualquier consulta relacionada con estos Términos y Condiciones:\n\n contacto@timearrival.com",
    highlight: "Contacto"
  }];
  return <section data-section-id="4124" id="términos-y-condiciones" className="relative bg-background text-foreground min-h-screen py-24 md:py-32 px-6 md:px-12 lg:px-20 overflow-hidden">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.03] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' /%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' /%3E%3C/svg%3E\")"
    }} />

      <div className="relative mx-auto max-w-[1400px]">
        <div className="flex justify-start mb-12">
          <span className="font-mono text-[12px] tracking-[0.4em] uppercase text-primary">TÉRMINOS Y CONDICIONES</span>
        </div>

        <div ref={bodyRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-16 mb-32 transition-all duration-1000 ease-out ${bodyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-32 space-y-8">
              <div className="space-y-4">
                <h3 className="font-mono text-sm uppercase tracking-widest text-primary">NUESTROS TÉRMINOS</h3>
              </div>
              <Separator className="bg-border" />
            </div>
          </div>

          <div className="lg:col-span-7 lg:col-start-6">
            <div className="space-y-20">
              {philosophyParagraphs.map((paragraph, i) => <div data-index={i} key={paragraph.id} className="space-y-8">
                  <div className="flex items-baseline gap-4">
                    <span className="font-mono text-primary text-sm">
                      {String(paragraph.id).padStart(2, '0')}
                    </span>
                    <h3 className="font-default font-bold text-3xl uppercase tracking-tight">
                      {paragraph.highlight}
                    </h3>
                  </div>
                  <div className="space-y-6 text-lg leading-relaxed opacity-80">
                    <p className="!h-[225px]">{paragraph.text}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        <div ref={signatureRef} className={`pt-16 border-t border-border transition-all duration-1000 ease-out ${signatureVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
            <div>
              <p className="font-mono text-sm uppercase tracking-widest">JUNIO 2026</p>
            </div>
            <div className="flex gap-8">
              <div className="text-right">
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}